import { useLocaleText } from "../../../hooks/useLocaleText.js";
const resolveUser = (user) => {
  var _a;
  const texts = useLocaleText();
  if (user) {
    const userData = {
      header: user.username,
      href: "https://mit.ida.dk",
      icon: "User",
      iconVariant: "filled",
      special: {
        text: texts.logout,
        href: user.logoutLink || "/logout",
        chevron: "Logout"
      },
      items: ((_a = user.links) == null ? void 0 : _a.map((item) => ({
        header: item.header,
        links: item.items || [],
        href: item.href
      }))) || []
    };
    return userData;
  }
  return {
    header: texts.logOnMitIda,
    href: "https://mit.ida.dk",
    icon: "User",
    iconVariant: "filled"
  };
};
export {
  resolveUser
};
